import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  companyList: [],
  companyDetail: [],
  companyFormList: [],
  companyFormDetail: [],
  loading: false,
  error: undefined,
};

const companySlice = createSlice({
  name: "company",
  initialState,
  reducers: {
    clearError(state) {
      state.error = undefined;
    },
    actionStart(state) {
      state.loading = true;
      state.error = undefined;
    },
    fetchCompanyList(state, action) {
      state.companyList = action.payload;
      state.loading = false;
    },
    fetchCompanyDetail(state, action) {
      state.companyDetail = action.payload;
      state.loading = false;
    },
    fetchCompanyFormList(state, action) {
      state.companyFormList = action.payload;
      state.loading = false;
    },
    fetchCompanyFormListClear(state) {
      state.companyFormList = [];
      state.loading = false;
    },
    fetchCompanyFormDetail(state, action) {
      state.companyFormDetail = action.payload;
      state.loading = false;
    },
  },
});

export const companyActions = companySlice.actions;

export default companySlice.reducer;
